
<div (keydown)="TraiterClavier($event)">
  <kendo-numerictextbox #editeurNumerique
                        [spinners]="false"
                        [format]="formatSaisie"
                        [decimals]="nombreDecimale"
                        (blur)="ChangerValeurFiltre()"
                        [(ngModel)]="valeur">
  </kendo-numerictextbox>
</div>
<kendo-grid-filter-cell-operators class="val-filter-cell-operateur"
                                  [column]="column"
                                  [(value)]="operateur"
                                  [showOperators]="true"
                                  [operators]="[{text: 'Egal', value: 'eq'}, {text: 'Inférieur ou égal', value: 'lte'}, {text: 'Supérieur ou égal', value: 'gte'}]"
                                  (valueChange)="ChangerOperateur()">
</kendo-grid-filter-cell-operators>
<button kendoButton
        class="val-bouton-effacer-filtre"
        [ngClass]="{'val-invisible': !boutonEffacerVisible}"
        [svgIcon]="boutonEffacerIcone"
        (click)="Effacer()">
</button>
